<template>
  <div v-if="isInitial" class="content-wrapper">
    <div id="isInitial" class="container">
      <article>
        <section class="section white-panel radius8 mt3p mr3p mb2p ml3p topics-panel">
          <h2 class="fs16 bdb-solid-gray2 mb16 pt4 pb16">コミっと車検実施のお礼</h2>
          <p class="fs14">この度は、コミっと車検をご利用いただきまして誠にありがとうございます。</p>
          <p class="fs14">車検後のお車の具合はいかがでしょうか。<br>コミっと車検では、定額対象整備部品および交換した部品の整備保証※¹と無料の法定12ヵ月点検※²を提供しております。保証整備や点検については、車検をしたSSまでお問い合わせください。<a href="#" class="color-green2" v-on:click="toAgreement()">保証の詳細はこちら</a></p>
          <p>※¹ 車検後半年または走行距離1万km以内で対象部品に異常がある場合<br>※² 点検の結果、整備・部品交換に追加費用が発生する場合があります。</p>
          <p class="fs14">また、日々のお車のメンテナンスについても喜んで対応させていただきますので、気軽にお立ち寄りください。</p>
        </section>

        <section class="section white-panel radius8 mt3p mr3p mb2p ml3p topics-panel">
          <div class="flex align-items-center bdb-solid-gray2 pb4 mb16">
            <img src="/lib/images/ic_car1.png" width="44" height="44" alt="" class="radius50p">
            <div class="flex1 ml12">
              <h2 class="fs16">アンケートご協力のお願い</h2>
            </div>
          </div>
          <p class="fs14">コスモでは日々ご利用いただいたお客様からの率直なご意見を頂戴し、サービス向上を図ることを目的としたアンケートを実施しております。本アンケートのご回答内容を「お客様の声」として、当社WEBサイト等の広告・告知媒体に掲載させていただく場合がございます。また、本アンケートで取得した個人情報については、【コスモの公式】アプリのプライバシーポリシーに従って取扱います。ご協力いただける方は下記リンクよりアンケートにお答えいただきますようお願いいたします。なお、所要時間は3分程度となっております。</p>
          <button class="button fs16 mt16 mb8 pd16 radius200 w85p" v-on:click="moveGoogleForm()">アンケート記入へ進む</button>
        </section>
      </article>
    </div>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<script>
import Agreement from '@/views/v3/Agreement.vue'
import inspection from '@/store/Api/inspection'
import modal from '@/assets/v3/modal'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data () {
    return {
      tsId: '',
      ssCd: '',
      inspectionId: null,
      currentState: IS_INITIAL,
      recommendProgramUrl: 'https://commit.carlifesquare.com/column/campaign/recommend'
    }
  },
  methods: {
    moveGoogleForm () {
      const googleFormUrl = process.env.VUE_APP_GOOGLEFORM_THANKS_URL
      const tsIdEntry = '&entry.237743993=' + this.tsId
      const ssCdEntry = '&entry.938603573=' + this.ssCd
      const url = googleFormUrl + tsIdEntry + ssCdEntry
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    },
    toInitial () {
      // 戻るボタンの出し分け
      this.appDisplayBack(false)
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
    },
    toAgreement () {
      // 戻るボタンの出し分け
      this.appDisplayBack(true)
      this.currentState = IS_AGREEMENT
      window.scrollTo(0, 0)
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    jsOpenBrowser: function (url) {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    }
  },
  computed: {
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    let isApiError = false

    this.inspectionId = this.$route.query.inspectionid

    await inspection.getDetail(this.inspectionId).then(res => {
      this.ssCd = res.data[0].inspection_estimate.ss_code
      this.tsId = res.data[0].ts_id
    }).catch(e => {
      console.log(e)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    this.nativePVset('SHAKEN_THANKS')
  },
  components: {
    Agreement
  }
}
</script>

<style></style>
